'use client';

import { createContext, useContext, type ReactNode } from 'react';

export interface IntegrationSetupContextValue {
  /** Selectors render inline inside the catalog's one setup dialog. */
  embedded: boolean;
  onboarding: boolean;
  returnTo?: string;
  /** Call after the provider has finished authentication AND resource selection. */
  onConfigured?: () => void;
}

const IntegrationSetupContext = createContext<IntegrationSetupContextValue>({
  embedded: false,
  onboarding: false,
});

export function IntegrationSetupProvider({
  children,
  ...value
}: IntegrationSetupContextValue & { children: ReactNode }) {
  return (
    <IntegrationSetupContext.Provider value={value}>{children}</IntegrationSetupContext.Provider>
  );
}

export function useIntegrationSetup() {
  return useContext(IntegrationSetupContext);
}
